import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["enableHover", "imageHeight", "imageWidth", "limit", "showDiscount", "showDiscountOnlyCashInfo", "showInCashLabel", "allowEmptyRating", "attributeStyle", "colorMinLength", "gridGap", "isSellerPage", "isSlider", "slidesPerView", "desktopMode", "itemWidth", "itemHeight"];
import React from 'react';
import { bool, string, number, shape } from 'prop-types';
import ProductListModule from '@magalu/stereo-ui/organisms/ProductList';
import { filtersParser, routePush } from '@magalu/mixer-utils';
import { usePublisher } from '@magalu/mixer-publisher';
import isServiceType from '../../../commons/isServiceType';
import withLayoutProps from '../../../hocs/withLayoutProps';
import useProductList from './useProductList';
var offerTimerProps = {
  bg: 'primary'
};
var shouldShowWishButton = function shouldShowWishButton(isSellerPage, showWishBtn) {
  return !isSellerPage && showWishBtn;
};
var ProductList = function ProductList(_ref) {
  var _data$search, _data$search$fastFilt, _structure$theme;
  var data = _ref.data,
    _ref$static = _ref["static"],
    _ref$static2 = _ref$static === void 0 ? {} : _ref$static,
    _ref$static2$enableHo = _ref$static2.enableHover,
    enableHover = _ref$static2$enableHo === void 0 ? false : _ref$static2$enableHo,
    imageHeight = _ref$static2.imageHeight,
    imageWidth = _ref$static2.imageWidth,
    _ref$static2$limit = _ref$static2.limit,
    limit = _ref$static2$limit === void 0 ? 0 : _ref$static2$limit,
    showDiscount = _ref$static2.showDiscount,
    showDiscountOnlyCashInfo = _ref$static2.showDiscountOnlyCashInfo,
    _ref$static2$showInCa = _ref$static2.showInCashLabel,
    showInCashLabel = _ref$static2$showInCa === void 0 ? true : _ref$static2$showInCa,
    _ref$static2$allowEmp = _ref$static2.allowEmptyRating,
    allowEmptyRating = _ref$static2$allowEmp === void 0 ? false : _ref$static2$allowEmp,
    attributeStyle = _ref$static2.attributeStyle,
    colorMinLength = _ref$static2.colorMinLength,
    _ref$static2$gridGap = _ref$static2.gridGap,
    gridGap = _ref$static2$gridGap === void 0 ? 2 : _ref$static2$gridGap,
    _ref$static2$isSeller = _ref$static2.isSellerPage,
    isSellerPage = _ref$static2$isSeller === void 0 ? false : _ref$static2$isSeller,
    _ref$static2$isSlider = _ref$static2.isSlider,
    isSlider = _ref$static2$isSlider === void 0 ? false : _ref$static2$isSlider,
    slidesPerView = _ref$static2.slidesPerView,
    desktopMode = _ref$static2.desktopMode,
    itemWidth = _ref$static2.itemWidth,
    itemHeight = _ref$static2.itemHeight,
    staticProps = _objectWithoutProperties(_ref$static2, _excluded),
    structure = _ref.structure;
  var _ref2 = useProductList({
      data: data,
      "static": staticProps,
      structure: structure
    }) || {},
    display = _ref2.display,
    domain = _ref2.domain,
    handleAddToWishlist = _ref2.handleAddToWishlist,
    handleListShowMore = _ref2.handleListShowMore,
    handleProductMouseDown = _ref2.handleProductMouseDown,
    handleProductClick = _ref2.handleProductClick,
    handleProductView = _ref2.handleProductView,
    handleThumbnailClick = _ref2.handleThumbnailClick,
    handleVariationClick = _ref2.handleVariationClick,
    isEmptyList = _ref2.isEmptyList,
    products = _ref2.products,
    showWishilistButton = _ref2.showWishilistButton,
    handleAddToCart = _ref2.handleAddToCart,
    showAddToCartButton = _ref2.showAddToCartButton,
    ref = _ref2.ref;
  var showWishButton = shouldShowWishButton(isSellerPage, showWishilistButton);
  var _usePublisher = usePublisher(),
    publish = _usePublisher.publish;
  var parsedFilters = (data == null ? void 0 : (_data$search = data.search) == null ? void 0 : (_data$search$fastFilt = _data$search.fastFilters) == null ? void 0 : _data$search$fastFilt.length) > 1 && !desktopMode ? filtersParser({
    customCategoryFilter: false,
    data: data,
    filters: data.search.fastFilters,
    query: {},
    removeFilters: [],
    structure: structure
  }) : null;
  var onFilterClick = function onFilterClick(e, filter) {
    var _filter$values;
    e.preventDefault();
    var filters = ((_filter$values = filter.values) == null ? void 0 : _filter$values.length) ? filter.href.replace("".concat(filter.filterSlug, "---").concat(filter.slug), "".concat(filter.filterSlug, "---").concat(filter.values.join('--'))) : filter.href;
    publish('productlist:fastFilter:click', _extends({}, filter, {
      custom: false
    }));
    routePush({
      path: filters,
      spa: true
    });
  };
  var onFilterView = function onFilterView(_ref3) {
    var _filter$values2, _filter$values2$flatM;
    var filter = _ref3.filter;
    var eventLabel = filter == null ? void 0 : (_filter$values2 = filter.values) == null ? void 0 : (_filter$values2$flatM = _filter$values2.flatMap(function (item, idx) {
      return "".concat(idx + 1, "\xB0").concat(item.label, ":").concat(item.slug);
    })) == null ? void 0 : _filter$values2$flatM.join(';');
    publish('productlist:fastFilter:view', {
      custom: false,
      eventLabel: eventLabel
    });
  };
  return React.createElement(ProductListModule, {
    ref: ref,
    key: products,
    enableHover: enableHover,
    showInCashInfo: showInCashLabel,
    onClick: handleProductClick,
    onMouseDown: handleProductMouseDown,
    onClickLoadMore: handleListShowMore,
    data: products,
    displayMode: display,
    domain: domain,
    onProductView: handleProductView,
    partial: limit,
    notFound: isEmptyList,
    showWishBtn: showWishButton,
    onClickWishBtn: handleAddToWishlist,
    imageWidth: imageWidth,
    imageHeight: imageHeight,
    showDiscount: showDiscount,
    showDiscountOnlyCashInfo: showDiscountOnlyCashInfo,
    allowEmptyRating: allowEmptyRating,
    onThumbnailClick: handleThumbnailClick,
    onVariationClick: handleVariationClick,
    colorMinLength: colorMinLength,
    attributeStyle: attributeStyle,
    offerTimerProps: (structure == null ? void 0 : (_structure$theme = structure.theme) == null ? void 0 : _structure$theme.name) === 'magazineluiza-bf' ? offerTimerProps : undefined,
    gridGap: gridGap,
    isSellerPage: isSellerPage,
    isSlider: isSlider,
    addToCart: handleAddToCart,
    showAddToCartButton: showAddToCartButton,
    hidePriceWhen: isServiceType,
    hideShippingTagWhen: isServiceType,
    inlineFilters: parsedFilters,
    onFilterClick: onFilterClick,
    onFilterView: onFilterView,
    filterSlidesPerView: slidesPerView,
    filterItemHeight: itemHeight,
    desktopMode: desktopMode
  });
};
process.env.NODE_ENV !== "production" ? ProductList.propTypes = {
  data: shape({}),
  "static": shape({
    allowEmptyRating: bool,
    context: shape({}),
    display: string,
    domain: string,
    gridGap: number,
    inCashDescription: string,
    isSellerPage: bool,
    isSlider: bool,
    limit: number,
    origin: string,
    pageSize: number,
    position: number,
    showDiscount: bool,
    showDiscountOnlyCashInfo: bool,
    showInCashLabel: bool,
    showWishBtn: bool,
    spa: bool,
    type: string
  }),
  structure: shape({})
} : void 0;
ProductList.defaultProps = {
  data: {},
  "static": {},
  structure: {}
};
ProductList.ssr = true;
ProductList.displayName = 'ProductList';
ProductList.dataSource = {
  search: {
    query: 'SearchQuery'
  }
};
export default withLayoutProps(ProductList);